import { Box } from "@mui/material";
import React from "react";
import EditableTable from "components/smea/Table/EditableTable";

export default function SchoolDataTable({ data, loadingState }) {
  const columns = [
    // { field: "id", headerName: "ID", width: 100 },
    {
      field: "quarter",
      headerName: "Quarter",
      width: 150,
      valueGetter: (params) => {
        if (params.value === 1) {
          return "First Quarter";
        }
        if (params.value === 2) {
          return "Second Quarter";
        }
        if (params.value === 3) {
          return "Third Quarter";
        }
        if (params.value === 4) {
          return "Fourth Quarter";
        }
        return null;
      },
    },
    {
      field: "subject",
      headerName: "Subject",
      width: 310,
      valueGetter: (params) => {
        const subject = params.value;

        return subject?.name;
      },
    },
    {
      field: "components",
      headerName: "Component",
      width: 150,
      valueGetter: (params) => {
        const component = params.value;

        return component?.name;
      },
    },
    { field: "gradeLevel", headerName: "Grade Level", width: 150 },
    {
      field: "overallAverageMPS",
      headerName: "Average MPS",
      width: 150,
      valueGetter: (params) => {
        const value = parseFloat(params?.value).toFixed(2);
        return value;
      },
    },
    {
      field: "overallAverageSD",
      headerName: "Average SD",
      width: 150,
      valueGetter: (params) => {
        const value = parseFloat(params?.value).toFixed(2);
        return value;
      },
    },
    {
      field: "status",
      headerName: "Submit Type",
      width: 150,
      valueGetter: (params) =>
        // eslint-disable-next-line no-nested-ternary
        params?.value === 1
          ? "Submitted"
          : params?.value === 0
          ? "Saved"
          : "Unknown",
    },
  ];

  return (
    <Box>
      <EditableTable
        data={data}
        columns={columns}
        loading={loadingState}
        // rowToView={setRowToView}
        singleSelect
        height="60vh"
        showSearch
      />
    </Box>
  );
}
